import {getCookie, SYSTEM_COOKIES} from "./cookies.ts";
import {getUserToken} from "../api/auth.ts";
import {getLocalStorageItem, SYSTEM_LOCAL_STORAGE} from "./localStorage.ts";

export class AuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AuthError";
  }
}

export const TOKEN_EXPIRATION = new Date(Date.now() + 6000 * 1000);

export async function getToken(formData: FormData) {
  const code = formData.get("code") as string;
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;
  if(!email && !password && !code) throw new AuthError("Invalid code");
  
  const formDataToSubmit = new FormData();
  
  if(code) {
    formDataToSubmit.set('otp', code);
    formDataToSubmit.set('method', 'otp');
  } else {
    formDataToSubmit.set('email', email);
    formDataToSubmit.set('password', password);
    formDataToSubmit.set('method', 'password');
  }
  
  
  const response = await getUserToken(formDataToSubmit);
  return response.token;
}

export function isAuthenticated() {
  return !!getLocalStorageItem(SYSTEM_LOCAL_STORAGE.USER) && !!getCookie(SYSTEM_COOKIES.TOKEN);
}